export const MAX_STREAMS = 6;
